import axios from 'axios';
import { appConfig } from '../runtimeConfig';

/**
 * Shared Axios instance.
 * In development, the Vite proxy rewrites /api -> http://localhost:3001/api.
 * In production, VITE_API_BASE_URL points to the cluster ingress.
 */
export const apiClient = axios.create({
  baseURL: `${appConfig.apiBaseUrl}/api`,
  timeout: 30_000,
});

/**
 * Attach the Auth0 bearer token to every request.
 * Call setAuthToken(token) after Auth0 provides a token.
 */
export function setAuthToken(token: string | null) {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
}

/**
 * Set up response interceptor to handle 403 NOT_ALLOWED errors.
 * This is called once when the app initializes.
 */
export function setupErrorInterceptors() {
  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const errorCode = error.response?.data?.code;

      // Redirect when API auth failed before route-level authorization.
      if (
        error.response?.status === 403 &&
        ['NOT_ALLOWED', 'NO_EMAIL_IN_TOKEN', 'NO_USER_CONTEXT'].includes(errorCode)
      ) {
        // Redirect to access denied page
        window.location.href = '/access-denied';
        // Don't re-throw; let the redirect happen
        return new Promise(() => {
          // Never resolves, allowing the redirect to complete
        });
      }

      // Re-throw other errors
      return Promise.reject(error);
    }
  );
}

